<div class="service-page service-index">
  <header class="page-hero">
    <h1>La solución adecuada empieza por entender el problema.</h1>
    <p class="hero-lead">
      Desarrollo web, programas internos, integraciones y mantenimiento para medianas empresas que
      necesitan avanzar con un alcance claro y un precio acordado desde el inicio.
    </p>
    <a class="button button-primary" routerLink="/contacto">Cuéntanos qué necesitas</a>
  </header>

  <section aria-labelledby="choose-title">
    <div class="section-heading">
      <h2 id="choose-title">Cuatro servicios para necesidades distintas.</h2>
      <p>Cada proyecto se plantea según su objetivo, sin añadir complejidad que no aporte valor.</p>
    </div>
    <div class="service-cards">
      <article>
        <h3>Desarrollo web</h3>
        <p class="service-price">Desde 690 € + IVA</p>
        <p>
          Landing esencial, web profesional o web avanzada según el contenido, la autonomía y las
          integraciones que necesite el negocio.
        </p>
        <ul>
          <li>Landing esencial desde 690 € + IVA</li>
          <li>Web profesional desde 1.290 € + IVA</li>
          <li>Web avanzada desde 2.490 € + IVA</li>
        </ul>
        <a routerLink="/servicios/desarrollo-web">Explorar desarrollo web</a>
      </article>
      <article>
        <h3>Desarrollo personalizado</h3>
        <p class="service-price">Presupuesto cerrado</p>
        <p>
          Para necesidades que una web convencional no resuelve: aplicaciones, integraciones o
          herramientas internas.
        </p>
        <ul>
          <li>Procesos específicos del negocio</li>
          <li>Conexión entre herramientas</li>
          <li>Aplicaciones web para empresas</li>
        </ul>
        <a routerLink="/servicios/desarrollo-personalizado">Explorar desarrollo personalizado</a>
      </article>
      <article>
        <h3>Mantenimiento web</h3>
        <p class="service-price">Desde 59 €/mes + IVA</p>
        <p>
          Para conservar una web estable y actualizada, o valorar mejoras a medida que cambia el
          negocio.
        </p>
        <ul>
          <li>Plan esencial: 59 €/mes + IVA</li>
          <li>Plan profesional: 149 €/mes + IVA</li>
          <li>Plan personalizado a medida</li>
        </ul>
        <a routerLink="/servicios/mantenimiento">Explorar mantenimiento web</a>
      </article>
      <article>
        <h3>Hosting y dominios</h3>
        <p class="service-price">19 €/mes o 190 €/año + IVA</p>
        <p>
          Servicio independiente para landings esenciales y webs profesionales desarrolladas por
          ATSIestudio.
        </p>
        <ul>
          <li>Gestión del alojamiento</li>
          <li>Configuración del dominio</li>
          <li>Seguimiento y renovaciones</li>
        </ul>
        <a routerLink="/servicios/hosting-y-dominios">Explorar hosting y dominios</a>
      </article>
    </div>
  </section>

  <section class="pricing-note" aria-labelledby="pricing-note-title">
    <div>
      <h2 id="pricing-note-title">Importes de partida, sin IVA incluido.</h2>
    </div>
    <p>
      El presupuesto final dependerá del alcance concreto, el número de páginas, las integraciones,
      el contenido disponible y la complejidad técnica del proyecto.
    </p>
  </section>

  <section class="decision-section" aria-labelledby="decision-title">
    <div>
      <h2 id="decision-title">No necesitas llegar con la solución decidida.</h2>
    </div>
    <div>
      <p>
        Puedes explicar el punto de partida y el resultado que buscas. A partir de ahí se puede
        ordenar la necesidad y valorar qué tipo de servicio encaja mejor.
      </p>
      <a class="text-link" routerLink="/contacto">Hablar sobre tu proyecto</a>
    </div>
  </section>
</div>
